import { isCompactViewport, onViewportModeChange } from '../viewport/viewport_mode.js?v=20260731a';

// Werkzeugleisten-Akkordeon fuer den Kompakt-Modus (Phase 3, siehe
// project_responsive_mobile_20260731-Memo). Rein CSS-Klassen-basiert auf
// den bestehenden, UNVERAENDERTEN Karten-Renderern
// (global_menu_renderer.js/system_navigation.js) — es wird nie selbst neu
// gerendert oder ein Button dupliziert, nur is-expanded/is-collapsed auf die
// bereits vorhandenen .command-card-Elemente gesetzt. Dadurch bleiben alle
// bestehenden Event-Delegationen (bindGlobalMenuToolbarEvents, der
// System-Toolbar-Click-Handler in app_event_controller.js) unangetastet —
// dieses Modul haengt sich nur zusaetzlich an dieselben Container.
//
// Pro Zeile (global/systembedingt) ist immer genau eine Karte "offen".
// Klick auf eine GESCHLOSSENE Karte oeffnet sie und schliesst automatisch
// die vorher offene in DERSELBEN Zeile — nie beide Zeilen gemeinsam, jede
// Zeile hat ihren eigenen Zustand. Default: erste Karte. Verschwindet die
// aktuell offene Karte aus dem DOM (z.B. Systemwechsel raeumt die
// Karten-Liste neu auf), springt der Default automatisch wieder auf die
// erste vorhandene Karte.
//
// #systemToolbar wird laut system_navigation.js's eigenem Kommentar bei
// JEDER App-Aktualisierung komplett per innerHTML neu aufgebaut (Button-
// Aktiv-Zustand ist Teil des HTML-Strings) — ein MutationObserver statt
// eines einmaligen Bindings ist hier deshalb notwendig, nicht nur
// vorsichtshalber.

const ROWS = [
  { containerId: 'globalMenuToolbar', expandedCardId: null },
  { containerId: 'systemToolbar', expandedCardId: null }
];

function cardsIn(container) {
  return [...container.querySelectorAll(':scope > [data-toolbar-card]')];
}

function applyRowState(row) {
  const container = document.getElementById(row.containerId);
  if (!container) return;
  const cards = cardsIn(container);
  if (!cards.length) return;
  if (!cards.some(card => card.dataset.toolbarCard === row.expandedCardId)) {
    row.expandedCardId = cards[0].dataset.toolbarCard;
  }
  cards.forEach(card => {
    const expanded = card.dataset.toolbarCard === row.expandedCardId;
    card.classList.toggle('is-expanded', expanded);
    card.classList.toggle('is-collapsed', !expanded);
  });
}

function clearRowState(row) {
  const container = document.getElementById(row.containerId);
  container?.querySelectorAll('[data-toolbar-card]').forEach(card => {
    card.classList.remove('is-expanded', 'is-collapsed');
  });
}

function applyAllRows() {
  ROWS.forEach(isCompactViewport() ? applyRowState : clearRowState);
}

function onRowClick(row, event) {
  if (!isCompactViewport()) return;
  const card = event.target.closest('[data-toolbar-card]');
  if (!card || card.dataset.toolbarCard === row.expandedCardId) return;
  event.preventDefault();
  event.stopPropagation();
  row.expandedCardId = card.dataset.toolbarCard;
  applyRowState(row);
}

export function initToolbarAccordion() {
  ROWS.forEach(row => {
    const container = document.getElementById(row.containerId);
    if (!container) return;
    // Capture-Phase: greift vor bindGlobalMenuToolbarEvents' eigenem
    // Bubble-Phase-Listener auf demselben Container, damit ein Oeffnen-Klick
    // auf eine geschlossene Karte sicher nicht zusaetzlich eine darunter
    // liegende Aktion (Button/Checkbox) auslöst.
    container.addEventListener('click', event => onRowClick(row, event), true);
    // Nur im Kompakt-Modus reagieren: #systemToolbar wird bei JEDER
    // App-Aktualisierung neu aufgebaut (auch ausserhalb des Kompakt-Modus,
    // z.B. durch den resize-Handler in app_event_controller.js) — ohne
    // diese Pruefung wuerde ein Refresh nach dem Verlassen des
    // Kompakt-Modus faelschlich wieder is-expanded/is-collapsed vergeben.
    new MutationObserver(() => {
      if (isCompactViewport()) applyRowState(row);
    }).observe(container, { childList: true });
  });
  applyAllRows();
  onViewportModeChange(applyAllRows);
}
